import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap-icons/font/bootstrap-icons.scss';
import './styles/custom.scss';

// FONTOS: a bundle-t importáld, ebben benne van a Popper is
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

// (opcionális) ha kell neked globálisan is:
(window as any).bootstrap = bootstrap;


(() => {
  // Kisegítők
  const fmtFt = (n) => Number(n || 0).toLocaleString('hu-HU');
  const parseIntSafe = (v, def=0) => {
    const n = parseInt(String(v ?? '').trim(), 10);
    return Number.isFinite(n) ? n : def;
  };

  // -------------------------------
  // 1) Dátumok / éjszakák + árkalkulátor (csak ha MINDEN kellék megvan)
  // -------------------------------
  (function initNightsAndPrice() {
    // dátumok forrása (opcionális)
    const startAttr = document.querySelector('[data-trip-start]')?.getAttribute('data-trip-start')
                   || document.getElementById('miniCalendar')?.dataset?.start
                   || null;
    const endAttr   = document.querySelector('[data-trip-end]')?.getAttribute('data-trip-end')
                   || document.getElementById('miniCalendar')?.dataset?.end
                   || null;

    const start = startAttr ? new Date(startAttr + 'T00:00:00') : null;
    const end   = endAttr   ? new Date(endAttr   + 'T00:00:00') : null;

    // éjszakák kiírásához (opcionális)
    const infoNights  = document.getElementById('nightsOutput') || null;
    const infoNights2 = document.getElementById('calcNightsField') || null;

    // ha megvannak a dátumok, számolunk; ha nem, ez a rész csendben kihagyható
    let nights = 0;
    if (start instanceof Date && !isNaN(start) && end instanceof Date && !isNaN(end)) {
      nights = Math.max(1, Math.round((end - start) / (1000 * 60 * 60 * 24)));
      if (infoNights)  infoNights.textContent = nights || '—';
      if (infoNights2) infoNights2.value = nights || 0;
    } else {
      // nincs elég adat a dátumokhoz – ha vannak mezők, akkor “—”/0
      if (infoNights)  infoNights.textContent = '—';
      if (infoNights2) infoNights2.value = 0;
    }

    // --- ár kalkulátor csak akkor aktiv, ha a kötelező elemek megvannak
    const peopleInput     = document.getElementById('peopleInput') || null;
    const incBtn          = document.getElementById('incPeople') || null;
    const decBtn          = document.getElementById('decPeople') || null;
    const totalEl         = document.getElementById('totalPrice') || null;
    const calcPeopleField = document.getElementById('calcPeopleField') || null;
    const calcTotalField  = document.getElementById('calcTotalField') || null;

    // pricePppn hiányozhat – ilyenkor 0-nak vesszük, és ha nincs totalEl, akkor nincs mit csinálni
    const priceEl = document.getElementById('pricePppn') || null;
    const price   = parseIntSafe(priceEl?.value, 0);

    const canRunCalculator = !!(peopleInput && totalEl);

    if (!canRunCalculator) return; // nincs elég elem az árkalkulátorhoz, lépünk tovább

    function recalc() {
      const pRaw = parseIntSafe(peopleInput.value, 1);
      const p = Math.max(1, pRaw);
      const total = Math.max(0, price * p * (nights || 0));
      totalEl.textContent = fmtFt(total);
      if (calcPeopleField) calcPeopleField.value = p;
      if (calcTotalField)  calcTotalField.value  = total;
    }

    // események csak ha a gombok léteznek
    incBtn?.addEventListener('click', () => { try { peopleInput.stepUp(); } catch {} recalc(); });
    decBtn?.addEventListener('click', () => { 
      try { peopleInput.stepDown(); } catch {}
      if (parseIntSafe(peopleInput.value, 1) < 1) peopleInput.value = 1;
      recalc();
    });
    peopleInput.addEventListener('input', recalc);

    // első számítás
    recalc();
  })();

  // -------------------------------
  // 2) Mini naptár (két hónap, tartomány kiemelés) – csak ha van root ÉS dátumok
  // -------------------------------
  (function initMiniCalendar() {
    const calRoot = document.getElementById('miniCalendar');
    if (!calRoot) return;

    const startStr = calRoot.dataset?.start || document.querySelector('[data-trip-start]')?.getAttribute('data-trip-start') || null;
    const endStr   = calRoot.dataset?.end   || document.querySelector('[data-trip-end]')?.getAttribute('data-trip-end')   || null;
    if (!startStr || !endStr) return;

    const start = new Date(startStr + 'T00:00:00');
    const end   = new Date(endStr + 'T00:00:00');
    if (isNaN(start) || isNaN(end)) return;

    const months = [];
    const sameYM = (a,b) => a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth();
    const m1 = new Date(start.getFullYear(), start.getMonth(), 1);
    const m2 = sameYM(start, end) ? null : new Date(end.getFullYear(), end.getMonth(), 1);
    months.push(m1); if (m2) months.push(m2);

    const dayNames = ['H','K','Sze','Cs','P','Szo','V'];

    const renderMonth = (d) => {
      const y = d.getFullYear(), m = d.getMonth();
      const first = new Date(y, m, 1);
      const last  = new Date(y, m + 1, 0);
      const startIdx = (first.getDay() + 6) % 7;
      const days = last.getDate();

      const wrap = document.createElement('div');
      wrap.className = 'mb-3';

      const title = document.createElement('div');
      title.className = 'mb-2';
      title.innerHTML = `<strong>${y}. ${new Intl.DateTimeFormat('hu-HU', { month: 'long' }).format(d)}</strong>`;
      wrap.appendChild(title);

      const table = document.createElement('table');
      table.className = 'table table-sm mb-0';

      const thead = document.createElement('thead');
      const trh = document.createElement('tr');
      dayNames.forEach(n => {
        const th = document.createElement('th');
        th.textContent = n;
        trh.appendChild(th);
      });
      thead.appendChild(trh);
      table.appendChild(thead);

      const tbody = document.createElement('tbody');
      let day = 1 - startIdx;
      for (let r = 0; r < 6; r++) {
        const tr = document.createElement('tr');
        for (let c = 0; c < 7; c++, day++) {
          const td = document.createElement('td');
          td.className = 'text-center align-middle';
          if (day >= 1 && day <= days) {
            const cur = new Date(y, m, day);
            td.textContent = day;
            if (cur >= start && cur <= end) {
              td.classList.add('bg-highlight');
              if (+cur === +start) td.classList.add('bg-highlight-start');
              if (+cur === +end)   td.classList.add('bg-highlight-end');
            }
          } else {
            td.classList.add('text-muted');
            td.textContent = '';
          }
          tr.appendChild(td);
        }
        tbody.appendChild(tr);
      }
      table.appendChild(tbody);
      wrap.appendChild(table);
      return wrap;
    };

    calRoot.innerHTML = '';
    months.forEach(mm => calRoot.appendChild(renderMonth(mm)));
  })();

  // -------------------------------
  // 3) Lightbox (Bootstrap modal) – csak ha MINDEN fontos elem megvan és van legalább 1 kép
  // -------------------------------
    // ---- lightbox (Bootstrap modal) – képek nagyítása
(function initLightbox() {
  const modalEl  = document.getElementById('galleryModal');
  const modalImg = document.getElementById('galleryImg');
  if (!modalEl || !modalImg) return;

  let bsModal = null;
  try {
    bsModal = typeof bootstrap !== 'undefined' && bootstrap?.Modal
      ? new bootstrap.Modal(modalEl)
      : null;
  } catch { bsModal = null; }

  const nextBtn = document.getElementById('nextImg');
  const prevBtn = document.getElementById('prevImg');

  // képlistát HTML elemekből gyűjtjük
  const galleryButtons = Array.from(document.querySelectorAll('.gallery-open'));
  const images = galleryButtons.map(btn => btn.dataset.src?.trim()).filter(Boolean);

  if (!images.length || !galleryButtons.length) return;

  let current = 0;
  function show(idx) {
    current = (idx + images.length) % images.length;
    modalImg.src = images[current];
  }

  galleryButtons.forEach((btn, i) => {
    btn.addEventListener('click', () => {
      show(i);
      try { bsModal?.show(); } catch {}
    });
  });

  nextBtn?.addEventListener('click', () => show(current + 1));
  prevBtn?.addEventListener('click', () => show(current - 1));
  modalEl.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') show(current + 1);
    if (e.key === 'ArrowLeft')  show(current - 1);
  });
})();


  // -------------------------------
  // 4) Smooth scroll a foglalás gombra – teljesen opcionális
  // -------------------------------
  document.getElementById('startBookingBtn')?.addEventListener('click', () => {
    // anchor beállítva, CSS smooth scrollt használunk – ha nincs, semmi gond
  });
})();


(() => {
  const band = document.getElementById('elmeny-earthband');
  if (!band) return;

  const tiles = Array.from(band.querySelectorAll('[data-ripple]'));
  const svgs  = tiles.map(t => t.querySelector('svg.ripple-filter'));

  const play  = svg => { try { svg.unpauseAnimations(); } catch(_){} };
  const pause = svg => { try { svg.pauseAnimations(); } catch(_){} };

  svgs.forEach(pause);

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ isIntersecting, target }) => {
        const svg = target.querySelector('svg.ripple-filter');
        if (!svg) return;
        if (isIntersecting) play(svg); else pause(svg);
      });
    }, { threshold: 0.15 });
    tiles.forEach(t => io.observe(t));
  } else {
    svgs.forEach(play);
  }
})();